import { Injectable } from '@angular/core';

import { BaseGenerator } from './base.generator';

@Injectable()
export class ArticleGenerator extends BaseGenerator {
  constructor() {
    super('script', 'application/ld+json');
  }
}
